import { IonChip } from "@ionic/react";
import React from "react";

export type EntryInfoStatus = "incomplete" | "complete";

interface EntryInfoStatusChipProps {
    status: EntryInfoStatus;
}

const EntryInfoStatusChip: React.FC<EntryInfoStatusChipProps> = ({ status }) => {
    // If status is Complete, don't show the chip
    if (status === "complete") {
        return null;
    }

    return <IonChip className="text-white m-0 mt-2 mr-2 bg-warning">{status === "incomplete" ? "Incomplete" : "Complete"}</IonChip>;
};

export default EntryInfoStatusChip;
